import {
  CombinedCondition,
  FilterModel,
} from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { isCombinedCondition } from "@app/util/viewModel/assert";

import { OPERATORS_ALLOWING_EMPTY_VALUE } from "./consts";

const cleanUpCombinedCondition = (combinedCondition: CombinedCondition): CombinedCondition => {
  return {
    conditions: combinedCondition.conditions.filter((condition) => {
      if (isCombinedCondition(condition)) {
        const result = cleanUpCombinedCondition(condition);
        return !!result.conditions.length;
      } else {
        // Otherwise it's a simple condition

        return !(
          !OPERATORS_ALLOWING_EMPTY_VALUE.includes(condition.operator) &&
          (condition.value === undefined ||
            (Array.isArray(condition.value) && !condition.value.length))
        );
      }
    }),
    operator: combinedCondition.operator,
  };
};

export const cleanUpFilterModel = (filterModel: FilterModel): FilterModel => {
  return cleanUpCombinedCondition(filterModel);
};
